import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=curated%20premium%20sneaker%20and%20streetwear%20fashion%20display%20on%20elegant%20white%20shelving%20with%20warm%20cream%20backdrop%2C%20sophisticated%20retail%20boutique%20aesthetic%2C%20soft%20beige%20and%20sand%20tones%2C%20refined%20European%20product%20presentation%2C%20editorial%20fashion%20photography%20with%20natural%20shadows%20and%20luxurious%20minimalism&width=1600&height=800&seq=cta-bg-new-v2&orientation=landscape"
          alt="OOPBUY Spreadsheet Shopping"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/40 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              2026 OOPBUY<br />Spreadsheet Guide
            </h2>
            <p className="text-white/75 text-sm md:text-base leading-relaxed">
              Entdecke die besten Spreadsheet-Listen, Verkäufervergleiche und Shopping-Tipps für dein nächstes OOPBUY Erlebnis.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-900 text-white">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <Link
              to="/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full border border-white/25 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              Mehr erfahren
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}